import Collection from '../../collection';
import CustomField from '../../model/refbooks/field';

export default Collection.extend( {
	endpoint: 'fields/list',
	responseAt: 'custom_fields',
    model: CustomField,

	system() {
		return this.toJSON().filter( field => [true, 't'].includes( field.system ) )
	},

	nonSystem() {
		return this.toJSON().filter( field => [false, 'f'].includes( field.system ) )
	},
} );


// WEBPACK FOOTER //
// ./src/js/collection/refbooks/fields.js